import classNames from 'classnames';
import { useSidePanel } from 'features/app_shell/useSidePanel';
import { MfeShareableOutlet } from 'features/mfe_shareable';
import { RightRailOutlet } from 'features/right_rail';
import { SidebarPlaceholder } from 'features/sidebar_placeholder';
const sidePanelClosedCss = "sxbgcb5";
const sidePanelContainerCss = "sf00txe";
interface SidePanelProps {
  className?: string;
}

/**
 * Third-column panel in the app shell body row.
 * Animates in/out based on whether any side content is active (right rail, shareable, sidebar, user guide).
 * Visibility is driven by `useSidePanel`; the column collapses to zero-width when closed.
 *
 * @param className - Additional class applied to the container (e.g. shared `bodyPanelCss` border-radius).
 */
export const SidePanel = ({
  className
}: SidePanelProps) => {
  const isOpen = useSidePanel();
  return <div className={classNames(className, sidePanelContainerCss, {
    [sidePanelClosedCss]: !isOpen
  })} id="shell-side-panel" aria-hidden={!isOpen}>
      <MfeShareableOutlet />
      <RightRailOutlet />
      <SidebarPlaceholder />
    </div>;
};

require("./SidePanel.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SidePanel.tsx");